import React, { useEffect, useReducer, useState } from 'react'
import { Modal, ModalBody } from "react-bootstrap";
import { ServerRequestProtected } from '../../../../utils/ServerDataRequest';
import Loader from '../../../shared/Loader/Loader';
import { enumUtil } from '../../../../utils/Enum';
import isNull from '../../../../utils/NullChecking';
import NotificationHandler from '../../../../utils/NotificationHandler';
import SuperSearchList from '../../../shared/SuperSearch/SuperSearchList';
import { lazy, Suspense } from 'react';
import GridColumnHeader from '../../Shared/GridColumnHeader';
import { FindSecondChild } from '../../../../utils/FindMenuOption';

const Payerpopup = (props) => {
    let IsEditAllowed = FindSecondChild('Setup', 'Insurance', 'Insurance')?.IsAdd

    let TypeDD = [
        { display: "", value: "" },
        { display: "Commercial", value: "commercial" },
        { display: "Medicaid", value: "medicaid" },
        { display: "WorkersComp", value: "workerscomp" },
        { display: "Medicare", value: "medicare" },
        { display: "Bcbs ", value: "bcbs" },
    ]

    const { isOpenPayer, Close, CloseLoad } = { ...props }
    const API_URL_Integration = enumUtil.controller.Integration
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([])
    const [searchParam, setSearchParam] = useState();
    const [isChecked, setIsChecked] = useState([]);
    const [selectedData, setSelectedData] = useState([])
    const [Professional, setProfessional] = useState(false)
    const [Institutional, setInstitutional] = useState(false)
    const [savedata, setSaveData] = useState(false)
    const [ProfessionalAll, setProfessionalAll] = useState(false)
    const [InstitutionalAll, setInstitutionalAll] = useState(false)
    const [block, setBlock] = useState(true)

    const [typedropdown, SetTypeDropdown] = useState({
        PayerType: "",
        Payerdisplay: "",
    })



    ////////====GridColumnHeader=========//////////
    const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { defaultData: '', activeSortIcon: '' })




    const SearchOnEnter = (e) => {
        if (e.key === "Enter") {
            SearchByParam(searchParam, "searchParam")
        }
    }


    const LoadData = (param, type) => {
        setIsChecked(new Array(selectedData.length).fill(false));
        setSelectedData([])
        setIsLoading(true)
        ServerRequestProtected(API_URL_Integration + "/GetPayerList", 'post', {
            //   "TableName": enumUtil.enumAPITableName.Insurance,
            "Param": "ClaimMD",
            "SearchParam": param,
            "PayerType": type?.PayerType
        })
            .then((response) => {
                setIsLoading(false)
                const updatedList = response?.map(item => {
                    return {
                        ...item,
                        "Institutional": false,
                        "Professional": false

                    };
                });
                setData(updatedList)
                handleGridHeader({ defaultData: updatedList })

                setIsChecked(new Array(selectedData.length).fill(false));
                setSelectedData([])
            }).catch((error) => {
                setIsLoading(false)
            })
    }
    // const LoadData = (param, type, page = 1, limit = 10) => {
    //     setIsLoading(true);
    //     ServerRequestProtected(API_URL_Integration + "/GetPayerList", 'post', {
    //         "Param": "ClaimMD",
    //         "SearchParam": param,
    //         "PayerType": type?.PayerType,
    //         "Page": page,
    //         "Limit": limit
    //     })
    //         .then((response) => {
    //             setIsLoading(false);
    //             const updatedList = response?.map(item => {
    //                 return {
    //                     ...item,
    //                     "Institutional": false,
    //                     "Professional": false
    //                 };
    //             });

    //             // Append new data if not first page
    //             if (page === 1) {
    //                 setData(updatedList);
    //             } else {
    //                 setData((prevData) => [...prevData, ...updatedList]);
    //             }

    //             setIsChecked(new Array(updatedList.length).fill(false));
    //         })
    //         .catch((error) => {
    //             setIsLoading(false);
    //         });
    // };


    // console.log(data,'dataAfteraddnewfields');

    useEffect(() => {
        SetTypeDropdown({ ...typedropdown, PayerType: TypeDD?.[1]?.value, Payerdisplay: TypeDD?.[1]?.display })
    }, [])
    useEffect(() => {
        LoadData(searchParam, typedropdown)
    }, [typedropdown?.PayerType])

    const SearchByParam = () => {
        if (!isNull(searchParam)) {
            LoadData(searchParam, typedropdown)
        } else {
            LoadData("", typedropdown)
        }
    }
    const handleCheckboxChange = (e, index, item) => {

        if (item?.Added === "true") {
            e.preventDefault();
            NotificationHandler('This Insurance Already Added ', enumUtil.enumtoaster.warning)
        }
        else {
            const newCheckedState = [...isChecked];
            newCheckedState[index] = e.target.checked;
            if (e.target.checked) {
                const copyData = [...data];
                if (InstitutionalAll && ProfessionalAll) {
                    if (selectedData.length === 0) {
                        setSelectedData([index]);
                        copyData[index]["Institutional"] = true;
                        copyData[index]["Professional"] = true;
                        setData(copyData)
                    } else {
                        const newSelectedData = [...selectedData, index];
                        setSelectedData(newSelectedData);
                        const updatedList = copyData.map((item, idx) => {
                            if (newSelectedData.includes(idx)) {
                                return { ...item, Institutional: true, Professional: true };
                            }
                            return item;
                        });
                        setData(updatedList);
                    }
                }
                else if (InstitutionalAll) {
                    if (selectedData.length === 0) {
                        setSelectedData([index]);
                        copyData[index]["Institutional"] = true;
                        setData(copyData)
                    } else {
                        const newSelectedData = [...selectedData, index];
                        setSelectedData(newSelectedData);
                        const updatedList = copyData.map((item, idx) => {
                            if (newSelectedData.includes(idx)) {
                                return { ...item, Institutional: true };
                            }
                            return item;
                        });
                        setData(updatedList);
                    }
                }
                else if (ProfessionalAll) {
                    if (selectedData.length === 0) {
                        setSelectedData([index]);
                        copyData[index]["Professional"] = true;
                        setData(copyData)
                    } else {
                        const newSelectedData = [...selectedData, index];
                        setSelectedData(newSelectedData);
                        const updatedList = copyData.map((item, idx) => {
                            if (newSelectedData.includes(idx)) {
                                return { ...item, Professional: true };
                            }
                            return item;
                        });
                        setData(updatedList);
                    }
                }
                else {
                    if (selectedData.length === 0) {
                        setSelectedData([index]);
                    } else {
                        setSelectedData([...selectedData, index]);
                    }
                }
                // const newCheckedState = { ...isChecked, index: e.target.checked };
                setIsChecked(newCheckedState);
            }
            else {
                setSelectedData(selectedData.filter(item => item !== index));
            }
            setIsChecked(newCheckedState);
        }
    };


    const handleChangeProfessional = (e, index) => {
        const { name, checked } = e.target;
        const copyData = [...data];
        if (name === 'Professional') {
            if (checked) {

                copyData[index]["Professional"] = true;
            } else {
                copyData[index]["Professional"] = false
            }
        }

        setData(copyData);
    };
    const handleChangeInstitutional = (e, index) => {
        const { name, checked } = e.target;
        const copyData = [...data];
        if (name === 'Institutional') {
            if (checked) {
                copyData[index]["Institutional"] = true;
            } else {
                copyData[index]["Institutional"] = false
            }
        }
        setData(copyData);
    };
    const handleChangeCheckbox = (e) => {
        const { name, checked } = e.target;
        let copyData = [...data]
        if (name === "InstitutionalAll") {
            if (checked) {
                setInstitutionalAll(checked)
                let updateData = copyData.map((item, index) =>
                    selectedData.includes(index) ? { ...item, Institutional: true } : item
                );
                setData(updateData)
            }
            else {
                setInstitutionalAll(checked)
                let updateData = copyData.map((item, index) =>
                    selectedData.includes(index) ? { ...item, Institutional: false } : item
                );
                setData(updateData)
            }
        }
        else if (name === "ProfessionalAll") {
            if (checked) {
                setProfessionalAll(checked)
                let updateData = copyData.map((item, index) =>
                    selectedData.includes(index) ? { ...item, Professional: true } : item
                );
                setData(updateData)
            }
            else {
                setProfessionalAll(checked)
                let updateData = copyData.map((item, index) =>
                    selectedData.includes(index) ? { ...item, Professional: false } : item
                );
                setData(updateData)
            }
        }
    };

    const handleChange = (e) => {
        let { name, value } = e.target
        // let model = { ...typedropdown }
        if (name === "PayerType") {
            SetTypeDropdown({ ...typedropdown, Payerdisplay: value + "" })
        }
        // model[name] = value + ""
        // setmainModal(model)
    }
    const handleSelectedDataCategory = (selectedData, name) => {
        if (!isNull(selectedData)) {
            SetTypeDropdown({ ...typedropdown, PayerType: selectedData.value + "", Payerdisplay: selectedData.display })
            // setSelectedCategory(selectedData.display)
        }
        return selectedData
    }
    const handleSave = () => {
        if (IsEditAllowed) {
            if (selectedData.length === 0) {
                NotificationHandler('Please Select A Row', enumUtil.enumtoaster.warning)
                return
            } else {
                let SaveChildModal = {
                    PayerID: "",
                    Claims: "",
                    Eligibility: "",
                    ERA: "",
                    PayerName: "",
                    PayerType: "",
                    Professional: "",
                    Institutional: "",
                    attachment: '',
                }
                let SAveModal = []
                const SaveData = selectedData.map(index => data[index]);
                SaveData?.map((item, i) => {
                    SaveChildModal.PayerID = item.payerid
                    SaveChildModal.Claims = item.claims
                    SaveChildModal.Eligibility = item.eligibility
                    SaveChildModal.ERA = item.era
                    SaveChildModal.PayerName = item.payer_name
                    SaveChildModal.PayerType = item.payer_type
                    SaveChildModal.Professional = item.Professional + ""
                    SaveChildModal.Institutional = item.Institutional + ""
                    SaveChildModal.attachment = item.attachment + ""

                    SAveModal.push({ ...SaveChildModal })
                })

                // console.log('SAveModal', SAveModal);
                setIsLoading(true)
                ServerRequestProtected(API_URL_Integration + "/SaveInsurances", 'post', {
                    "TableName": enumUtil.enumAPITableName.InsuranceByMD,
                    "Param": "ClaimMD",
                    "ListofData": SAveModal,

                }).then((response) => {
                    setIsLoading(false)
                    NotificationHandler("Record Saved Successfully!", enumUtil.enumtoaster.success)
                    setSelectedData([]);
                    setIsChecked(new Array(selectedData.length).fill(false));
                    setSaveData(true)
                }).catch((error) => {
                    setIsLoading(false)
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
            }
        }
    }
    const [expandedRows, setExpandedRows] = useState([]);
    const toggleShowMore = (index) => {
        setExpandedRows((prev) =>
            prev.includes(index)
                ? prev.filter((i) => i !== index)
                : [...prev, index]
        );
    };

    return (
        <>
            {isLoading ? <Loader /> : null}
            <Modal show={isOpenPayer} onHide={savedata ? CloseLoad : Close} backdrop="static" keyboard={false} centered dialogClassName=" hk-modal-v1 za-payerlist">
                <Modal.Body>
                    <div className='d-flex justify-content-between align-items-center mb-2'>
                        <p className='heading fs-14 dark-clr'>Payer List</p>
                        <i className='icon-x-cros fs-20 dark-clr cursor-pointer' onClick={savedata ? CloseLoad : Close}></i>
                    </div>
                    <div className='d-flex justify-content-between align-items-center mb-2'>
                        <div className="col-md-8  d-flex align-items-center gap-10">
                            <div className="input form-rounded mb-0 w-65">
                                <div className='input-group hk-input-search'>
                                    <input type="text" className='form-control fc-xs' placeholder='Search by name or id…'
                                        onChange={e => setSearchParam(e.target.value)}
                                        onKeyDown={SearchOnEnter}
                                        value={searchParam}
                                    />
                                    <span className="input-group-text" onClick={SearchByParam}>
                                        <i className="bi bi-search"></i>
                                    </span>
                                </div>
                            </div>
                            <div className='w-35 multipleSearch-rounded'>
                                <div className=" input">
                                    <SuperSearchList
                                        type="client"
                                        id='PayerType'
                                        name='PayerType'
                                        searchValue={typedropdown.Payerdisplay}
                                        data={TypeDD}
                                        onChange={(e) => handleChange(e)}
                                        getSelectedData={handleSelectedDataCategory}
                                        icon={'Simple'}
                                        sup_btn='sup_simple_btn'
                                        sup_inp='superSearchVisitInp'
                                    />
                                </div>
                            </div>
                        </div>

                        <div className='col-md-2 multipleSearch-rounded'>
                            <div className=" input">
                                <SuperSearchList
                                    type="client"
                                    id='BillingDocumentType'
                                    name='BillingDocumentType'
                                    searchValue={'Claim MD'}
                                    data={[{ value: '', display: 'Claim MD' }]}
                                    onChange={() => ('')}
                                    getSelectedData={() => ('')}
                                    icon={'Simple'}
                                    sup_btn='sup_simple_btn'
                                    sup_inp='superSearchVisitInp'
                                />
                                {/* <select className="form-control fc-xs rounded-1" id="PaginationDefaultRows" name="RowsPerPage">
                                    <option className='text fs-12'>Claim MD</option>
                                </select> */}
                            </div>

                        </div>


                    </div>
                    <div className='payer_details p-2 d-flex justify-content-between align-items-center'>
                        <p className='heading fs-12'>Payer Details</p>
                        <div className='d-flex gap-2'>
                            <p className='text font-m'>Services:</p>
                            <div className='d-flex align-items-center gap-1'>
                                <div className="custom_check_box d-flex">
                                    <input
                                        type="checkbox"
                                        className="form-check-input p-0 mt-0"
                                        name='ProfessionalAll'
                                        id="ProfessionalAll"
                                        checked={ProfessionalAll}
                                        onChange={handleChangeCheckbox}
                                    />
                                </div>
                                <p className='text'>837P</p>
                            </div>
                            <div className='d-flex align-items-center gap-1'>
                                <div className="custom_check_box d-flex">
                                    <input
                                        type="checkbox"
                                        className="form-check-input p-0 mt-0"
                                        name='InstitutionalAll'
                                        id="InstitutionalAll"
                                        checked={InstitutionalAll}
                                        onChange={handleChangeCheckbox}
                                    />
                                </div>
                                <p className='text'>837I</p>
                            </div>
                        </div>
                        {/* <div className='d-flex align-items-center gap-2'>
                            <p className='text font-m fs-12'>Services:</p>
                            <div className='d-flex align-items-center gap-1'>
                                <div className="custom_check_box">
                                    <input
                                        type="checkbox"
                                        className="form-check-input p-0"
                                        name='IsAutoSubmittion'
                                        id='IsAutoSubmittion'
                                    />
                                </div>
                                <p className='text fs-12'>837P</p>
                            </div>
                            <div className='d-flex align-items-center gap-1'>
                                <div className="custom_check_box">
                                    <input
                                        type="checkbox"
                                        className="form-check-input p-0 "
                                        name='IsAutoSubmittion'
                                        id='IsAutoSubmittion'
                                    />
                                </div>
                                <p className='text fs-12'>837I</p>
                            </div>
                        </div> */}
                    </div>

                    <div className='card-body hk-expand-table ad-expand-table service_line'>
                        <table className='w-100'>
                            <thead>
                                <tr>
                                    <th className=''></th>
                                    <th className='heading fs-12'>
                                        {/* <GridColumnHeader
                                            gridHeader={gridHeader}
                                            handleGridHeader={handleGridHeader}
                                            iconName={'icon-card'}
                                            headerName={'Payer Name'}
                                            sortIcon={true}
                                            type={'string'}
                                            colKey={'payer_name'}
                                            data={data}
                                            setData={setData}
                                        /> */}
                                        Payer Name
                                    </th>
                                    <th className='heading fs-12'>
                                        {/* <GridColumnHeader
                                            gridHeader={gridHeader}
                                            handleGridHeader={handleGridHeader}
                                            iconName={'icon-card'}
                                            headerName={'Additional Names'}
                                            sortIcon={true}
                                            type={'string'}
                                            colKey={'payer_name'}
                                            data={data}
                                            setData={setData}
                                        /> */}
                                        Additional Names</th>
                                    <th className='heading fs-12'>Payer ID</th>
                                    <th className='heading fs-12'>Type</th>
                                    <th className='heading fs-12'>Services</th>
                                    <th className='heading fs-12'>Added</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data?.map((data, index) => {
                                    const payerNames = data?.alt_payer_name?.split(",") || [];
                                    const isExpanded = expandedRows.includes(index);
                                    return (
                                        <>
                                            <tr key={index}>
                                                <td>
                                                    <div className="custom_check_box d-flex justify-content-center align-items-center">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input p-0 mt-0 rounded-0"
                                                            name={`IsAutoSubmittion_${index}`}
                                                            id={`IsAutoSubmittion_${index}`}
                                                            checked={isChecked[index]}
                                                            onChange={(e) => handleCheckboxChange(e, index, data)}
                                                        />
                                                    </div>
                                                </td>
                                                <td className='text fs-12 ' title={data.payer_name}>
                                                    <div className='PayerName billing_to-do-list position-relative'>
                                                        <p className='text-nowrap validation_message'>{data.payer_name}</p>
                                                        {/* <div className="Name_card position-absolute todo-content">
                                                            <p className='heading fs-11 drk-green-clr'>Additional Names:</p>
                                                      
                                                        </div> */}


                                                    </div>
                                                </td>
                                                <td >
                                                    {payerNames
                                                        .slice(0, isExpanded ? payerNames.length : 2)
                                                        .map((name, i) => (
                                                            <p key={i} className="text fs-12 validation_message text-nowrap">
                                                                {name.trim()}
                                                            </p>
                                                        ))}
                                                    {payerNames.length > 2 && (
                                                        <p
                                                            className="text fs-10 validate-color text-decoration-underline text-end cursor-pointer"
                                                            onClick={() => toggleShowMore(index)}
                                                        >
                                                            {isExpanded ? "Show Less" : "Show More"}
                                                        </p>
                                                    )}

                                                    {/* <p className='text fs-10 validate-color text-decoration-underline text-end'>Show More</p> */}
                                                    {/* <p className='text fs-10 validate-color text-decoration-underline text-end'>Show Less</p> */}
                                                </td>
                                                <td><div className='text fs-12'>{data.payerid}</div></td>
                                                <td><div className='text fs-12'>{data.payer_type === 'commercial' ? "COMM" : data.payer_type === "workerscomp" ? "WC" : data.payer_type}</div></td>
                                                <td title={[
                                                    // data?.claims === 'yes' || data?.claims === 'enrollment' ? "837P " : "",
                                                    data?.claims === 'yes' ? '837P' : data?.claims === 'enrollment' ? '837P (Enrollment)' : '',
                                                    // data?.ub_claims === 'yes' || data?.ub_claims === 'enrollment' ? "837I " : "",
                                                    data?.ub_claims === 'yes' ? '837I' : data?.ub_claims === 'enrollment' ? '837I (Enrollment)' : '',
                                                    // data?.era === 'yes' || data?.era === 'enrollment' ? "ERA" : "",
                                                    data?.era === 'yes' ? 'ERA' : data?.era === 'enrollment' ? 'ERA (Enrollment)' : '',
                                                    // data?.auto === 'yes' || data?.auto === 'enrollment' ? "NF" : "",
                                                    data?.auto === 'yes' ? 'NF' : data?.auto === 'enrollment' ? 'NF (Enrollment)' : '',
                                                    // data?.workers_comp === 'yes' || data?.workers_comp === 'enrollment' ? "WC" : "",
                                                    data?.workers_comp === 'yes' ? 'WC' : data?.workers_comp === 'enrollment' ? 'WC (Enrollment)' : '',
                                                    // data?.eligibility === 'yes' || data?.eligibility === 'enrollment' ? "Eligibility" : "",
                                                    data?.eligibility === 'yes' ? 'Eligibility' : data?.eligibility === 'enrollment' ? 'Eligibility (Enrollment)' : '',
                                                    // data?.attachment === 'yes' || data?.attachment === 'enrollment' ? "Attachment" : ""
                                                    data?.attachment === 'yes' ? 'Attachment' : data?.attachment === 'enrollment' ? 'Attachment (Enrollment)' : '',
                                                ].filter(Boolean).join(', ')}>
                                                    <div className='text fs-12 text-nowrap validation_message' >
                                                        {[
                                                            // data?.claims === 'yes' || data?.claims === 'enrollment' ? "837P " : "",
                                                            data?.claims === 'yes' ? '837P' : data?.claims === 'enrollment' ? '837P (Enrollment)' : '',
                                                            // data?.ub_claims === 'yes' || data?.ub_claims === 'enrollment' ? "837I " : "",
                                                            data?.ub_claims === 'yes' ? '837I' : data?.ub_claims === 'enrollment' ? '837I (Enrollment)' : '',
                                                            // data?.era === 'yes' || data?.era === 'enrollment' ? "ERA" : "",
                                                            data?.era === 'yes' ? 'ERA' : data?.era === 'enrollment' ? 'ERA (Enrollment)' : '',
                                                            // data?.auto === 'yes' || data?.auto === 'enrollment' ? "NF" : "",
                                                            data?.auto === 'yes' ? 'NF' : data?.auto === 'enrollment' ? 'NF (Enrollment)' : '',
                                                            // data?.workers_comp === 'yes' || data?.workers_comp === 'enrollment' ? "WC" : "",
                                                            data?.workers_comp === 'yes' ? 'WC' : data?.workers_comp === 'enrollment' ? 'WC (Enrollment)' : '',
                                                            // data?.eligibility === 'yes' || data?.eligibility === 'enrollment' ? "Eligibility" : "",
                                                            data?.eligibility === 'yes' ? 'Eligibility' : data?.eligibility === 'enrollment' ? 'Eligibility (Enrollment)' : '',
                                                            // data?.attachment === 'yes' || data?.attachment === 'enrollment' ? "Attachment" : ""
                                                            data?.attachment === 'yes' ? 'Attachment' : data?.attachment === 'enrollment' ? 'Attachment (Enrollment)' : '',


                                                        ].filter(Boolean).join(', ')}
                                                    </div>

                                                </td>

                                                <td>
                                                    <div className='master_list_modal w-auto text-center text fs-12'>
                                                        <p className={`${data?.Added === "true" ? "Yes" : "No"} `}>{data?.Added === "true" ? "Yes" : "No"}</p>
                                                    </div>
                                                </td>
                                            </tr>
                                            {selectedData.includes(index) && (

                                                <tr className='checkbox-checked-row'>
                                                    <td colSpan={6}>
                                                        <div className='d-flex gap-2'>
                                                            <p className='text font-m'>Select services:</p>
                                                            <div className='d-flex align-items-center gap-1'>
                                                                <div className="custom_check_box d-flex">
                                                                    {ProfessionalAll ?
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-check-input p-0 mt-0"
                                                                            name='Professional'
                                                                            id="Professional"
                                                                            checked={data?.Professional}
                                                                        // onChange={(e) => handleChangeProfessional(e, index)}
                                                                        />
                                                                        :
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-check-input p-0 mt-0"
                                                                            name='Professional'
                                                                            id={`Professional-${index}`}
                                                                            checked={data?.Professional[index]}
                                                                            onChange={(e) => handleChangeProfessional(e, index)}
                                                                        />
                                                                    }


                                                                </div>
                                                                <p className='text'>837P</p>
                                                            </div>
                                                            <div className='d-flex align-items-center gap-1'>
                                                                <div className="custom_check_box d-flex">
                                                                    {InstitutionalAll ?
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-check-input p-0 mt-0"
                                                                            name='Institutional'
                                                                            id="Institutional"
                                                                            checked={data?.Institutional}
                                                                        // onChange={(e) => handleChangeInstitutional(e, index)}
                                                                        />
                                                                        :
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-check-input p-0 mt-0"
                                                                            name='Institutional'
                                                                            id={`Institutional-${index}`}
                                                                            checked={data?.Institutional[index]}
                                                                            onChange={(e) => handleChangeInstitutional(e, index)}
                                                                        />
                                                                    }
                                                                </div>
                                                                <p className='text'>837I</p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </>
                                    )
                                })}






                                {/* {data?.map((data, index) => {








                                    //  const payerNames = row?.alt_payer_name?.split(",") || [];
                                    //  const isExpanded = expandedRows.includes(index);
                                    return (

                                        {

                                        }
                                    )
                                })} */}
                            </tbody>
                        </table>
                    </div>
                </Modal.Body >
                <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-between ar_footer">
                    <div className='d-flex align-items-center gap-10'>
                        <div className='ar-alert d-flex align-items-center gap-1' >
                            <i className='icon-alert fs-16'></i>
                            <p className='text fs-11 fst-italic'>Eligibility and ERA would be added by default</p>

                        </div>
                        <div className='ar-alert d-flex align-items-center gap-1' >
                            <i className='icon-alert fs-16'></i>
                            <p className='text fs-11 fst-italic'>Services marked with enrollment need to be enrolled</p>
                        </div>
                    </div>

                    <div className="d-flex align-items-center gap-2">
                        <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={savedata ? CloseLoad : Close}>Cancel</button>
                        <button className={IsEditAllowed ? 'btn btn-validate px-10 h-100' : 'btn btn-validate px-10 h-100 disabled'} onClick={() => handleSave()}>Save</button>
                    </div>
                </div>

            </Modal >

        </>
    )
}

export default Payerpopup
